<section class="policy-body" *scRichText="rendering.fields.content">
</section>
